import styled from '@emotion/styled';

import { Container, TextBlockWithAside } from '@features';
import { getFont } from '@styles/mixins/fonts';
import { getMediaqueryStyled } from '@styles/mixins/mediaqueries';
import { sectionGridTemplateBase } from '@styles/mixins/sectionGridTemplate';
import { visuallyHidden } from '@styles/mixins/visuallyHidden';

export const StyledContainer = styled(Container)`
  --title-parts-margin: 0px;

  grid-template-areas:
    'first-title-part .'
    'second-title-part .'
    'text-block .';

  padding-bottom: 270px;

  ${sectionGridTemplateBase};

  ${getMediaqueryStyled('xl')} {
    --title-parts-margin: 10px;

    padding-bottom: 100px;
  }

  ${getMediaqueryStyled('lg')} {
    --title-parts-margin: 0px;

    padding-bottom: 85px;
  }

  ${getMediaqueryStyled('md')} {
    grid-template-areas: 'text-block';
    padding-top: 105px;
    padding-bottom: 90px;
  }

  ${getMediaqueryStyled('sm')} {
    padding-top: 90px;
  }
`;

export const Title = styled.h2`
  ${visuallyHidden}
`;

const TitlePart = styled.span`
  ${getFont('title')}

  ${getMediaqueryStyled('md')} {
    display: none;
  }
`;

export const TitleTopPart = styled(TitlePart)`
  grid-area: first-title-part;
  margin-bottom: var(--title-parts-margin);
`;

export const TitleBottomPart = styled(TitlePart)`
  grid-area: second-title-part;
  margin-left: 510px;
  margin-bottom: 100px;

  ${getMediaqueryStyled('xl')} {
    margin-left: 380px;
    margin-bottom: 105px;
  }

  ${getMediaqueryStyled('lg')} {
    margin-left: 255px;
    margin-bottom: 75px;
  }

  ${getMediaqueryStyled('md')} {
    justify-self: end;
    margin-left: 0;
  }
`;

export const TextBlock = styled(TextBlockWithAside)`
  grid-area: text-block;
`;

export const AsideText = styled.p`
  margin: 0;

  &:not(:last-child) {
    margin-bottom: 1.2rem;
  }

  a {
    color: var(--colors-green);
    text-decoration: none;
    transition: opacity var(--duration-base) linear;

    &:hover {
      opacity: 0.2;
    }
  }

  ${getMediaqueryStyled('md')} {
    margin: 0 auto;
    max-width: 305px;
    text-align: center;
    ${getFont('small')}
  }
`;
